import {
  Component,
  Input
} from '@angular/core';

@Component({
  selector: 'axis-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent {
  @Input() public dataProvider: any;
}
